<template>
  <v-container>
    <div class="tableTitle">時間</div>
    <table>
      <tr>
        <th>総実働時間​</th>
        <td>{{toFormattedTime(timeCounts.work + timeCounts.holidayWork)}}</td>
      </tr>

      <tr>
        <th>有休加算時間​</th>
        <td>{{toFormattedTime(timeCounts.paidDayOff)}}</td>
      </tr>
      <tr>
        <th>普通勤務時間</th>
        <td>{{toFormattedTime(timeCounts.work + timeCounts.holidayWork + timeCounts.paidDayOff - timeCounts.overtime)}}</td>
      </tr>
      <tr>
        <th>超過勤務時間</th>
        <td>{{toFormattedTime(timeCounts.overtime)}}</td>
      </tr>
      <tr>
        <th>うち深夜勤務時間</th>
        <td>{{toFormattedTime(timeCounts.holidayLateNight + timeCounts.lateNight)}}</td>
      </tr>

    </table>

  </v-container>
</template>
<script>

import { unixtimeToFormattedLargeTime} from "@/utils/datetime.js";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  data: () => ({}),
  props: {
  },
  computed: {
    ...mapGetters('timesheet', ['timeCounts'])
  },
  created() {},
  mounted(){

  },
  methods:{
    toFormattedTime(unixtime){
      return unixtimeToFormattedLargeTime(unixtime)
    }
  }
};
</script>
<style lang="scss" scoped>
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: right;
}
.tableSubTitle {
  font-size: 14px;
  color: #616161;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
</style>

